import { render, staticRenderFns } from "./EcommerceRenderer.vue?vue&type=template&id=17a84a1d&scoped=true"
import script from "./EcommerceRenderer.vue?vue&type=script&lang=js"
export * from "./EcommerceRenderer.vue?vue&type=script&lang=js"
import style0 from "./EcommerceRenderer.vue?vue&type=style&index=0&id=17a84a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a84a1d",
  null
  
)

export default component.exports